import React from "react";
import {connect} from "react-redux";
import {Link as RouterLink} from "react-router-dom";
import Link from '@material-ui/core/Link'
import {signup} from "../../actions/session";
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import {ThemeProvider, withStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {Field, reduxForm, SubmissionError} from "redux-form";
// import FormHelperText from "@material-ui/core/FormHelperText";
import _ from "lodash";
import styles from "./SignupStyles";

import {theme} from '../Dashboard/theme';
import Paper from "@material-ui/core/Paper";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Copyright from "../../components/Copyright";

let themeCustom = {
  ...theme,
};

const validate = values => {
  const errors = {};

  const requiredFields = [
    'firstName',
    'lastName',
    'email',
    'password',
    'password2',
    'acceptedDisclaimer'
  ];

  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required'
    }
  });

  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = 'Invalid email address'
  }
  return errors
};

// const renderFromHelper = (touched, error) => !(touched && error) ? null : touched && error;

class Signup extends React.Component {

  state = {
    open: false
  };

  handleClose = () => {
    this.setState({open: false})
  };

  handleOpen = () => {
    this.setState({open: 'open'})
  };

  renderCheckbox = ({input, label}) => (
    <div>
      <FormControlLabel
        control={
          <Checkbox
            checked={!!input.value}
            onChange={input.onChange}
            required={true}
          />
        }
        label={<Typography variant="body2" align="center">
          I accept the <span> </span>
          <Link onClick={this.handleOpen}>
            Medical Disclaimer
          </Link>
        </Typography>}

      />
    </div>
  );

  renderTextField = ({
                       input, label,
                       meta: {touched, invalid, error},
                       ...custom
                     }) => (
    <TextField
      style={{marginTop: '1px'}}
      label={label}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && invalid && error}
      variant="outlined"
      margine="normal"
      fullWidth

      {...input}
      {...custom}
    />
  );

  onSubmit = (formValues) => {
    return this.props.signup(formValues).then(() => {
      const {errors, message} = this.props.error;
      if (!_.isEmpty(errors)) {
        errors.forEach(error => {
          const myKeys = Object.keys(error);
          const key = myKeys[0];
          const value = error[key];
          if (key === 'email' || key === 'tag') {
            throw new SubmissionError({email: value, _error: message})
          }
          if (key === 'password') {
            throw new SubmissionError({password: value, _error: message})
          }
          if (key === 'password2') {
            throw new SubmissionError({password2: value, _error: message})
          }
        });
      }
    });
  };

  render() {
    const {classes, handleSubmit} = this.props;

    return (
      <ThemeProvider theme={themeCustom}>
        <Container component="main" maxWidth="xs" style={{
          minHeight: "100vh",
          minWidth: "100vw",
          display: "flex",
          flexDirection: "column"
        }}>
          <CssBaseline/>
          <Container className={classes.paper}
                     style={{marginTop: "1px",
                       flex: "1 0 auto",
                       maxWidth: "600px"
                     }}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon/>
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign up
            </Typography>
            <Grid>
              <Paper>
                <Container>
                  <form className={classes.form} noValidate onSubmit={handleSubmit(this.onSubmit)}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Field
                          name="firstName"
                          component={this.renderTextField}
                          label="First Name"
                          autoComplete="fname"
                          variant="outlined"
                          required
                          fullWidth
                          id="firstName"
                          autoFocus
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Field
                          name="lastName"
                          component={this.renderTextField}
                          variant="outlined"
                          required
                          fullWidth
                          id="lastName"
                          label="Last Name"
                          autoComplete="lname"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Field
                          variant="outlined"
                          component={this.renderTextField}
                          required
                          fullWidth
                          id="email"
                          label="Email Address"
                          name="email"
                          autoComplete="email"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Field
                          variant="outlined"
                          component={this.renderTextField}
                          required
                          fullWidth
                          name="password"
                          label="Password"
                          type="password"
                          id="password"
                          autoComplete="current-password"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Field
                          variant="outlined"
                          component={this.renderTextField}
                          required
                          fullWidth
                          name="password2"
                          label="Confirm Password"
                          type="password"
                          id="password2"
                          autoComplete="current-password"
                        />
                      </Grid>
                      <Grid>
                        <Field name="acceptedDisclaimer" component={this.renderCheckbox}/>
                      </Grid>
                      <Grid container justify="center">
                        <Button
                          type="submit"
                          variant="contained"
                          fullWidth
                          color="primary"
                          className={classes.submit}
                        >
                          Sign Up
                        </Button>
                      </Grid>
                      <Grid container justify="flex-end">
                        <Grid item style={{ marginTop: "24px" }}>
                          <Link component={RouterLink} to="/login" variant="body2">
                            Already have an account? Sign in
                          </Link>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Dialog
                      open={this.state.open}
                      onClose={this.handleClose}
                      scroll='paper'
                      aria-labelledby="scroll-dialog-title"
                      aria-describedby="scroll-dialog-description"
                    >
                      <DialogTitle id="scroll-dialog-title">Medical Disclaimer</DialogTitle>
                      <DialogContent dividers={true}>
                        <DialogContentText
                          id="scroll-dialog-description"
                          // ref={descriptionElementRef}
                          tabIndex={-1}
                        >
                          <Typography variant="body1">
                            Please note: If you are working on self-healing and you have a health condition that is
                            serious,
                            life-threatening or potentially life-threatening in any way then for you to participate in
                            any
                            classes it is mandatory for you to remain under the supervision of a licensed physician or
                            equivalent in your country of residence. No exceptions. Your goal should never be to avoid
                            your
                            doctors. It should be to obtain tangible results. As you obtain tangible results your
                            doctors should
                            be able to see that and your tests should reflect that. That is your goal. It is never to
                            avoid your
                            doctors.
                          </Typography>
                          <br/>
                          <br/>
                          <Typography variant="body1">
                            Your use of this website indicates that you clearly understand and fully agree to the
                            information
                            below.
                          </Typography>
                          <br/>
                          <Typography variant="body1">
                            All content contained on this website is licensed and owned by Brandy Gillmore and Gillmore
                            Innovations International. I understand that I may not reproduce, sell or in any other way
                            disseminate this information unless given express written authorization from Brandy Gillmore
                            and
                            Gillmore Innovations International.
                          </Typography>
                          <br/>
                          <Typography variant="body1">
                            I understand that I am responsible for my own health and health choices. Per Federal Law,
                            only a
                            medical doctor and/or prescription drug is able to make any claims to diagnose, treat,
                            prevent or
                            cure disease. I understand this website, including all verbal and written content cannot and
                            will
                            not make any promises or claims to do such. I understand it is always recommended that I
                            communicate
                            with my doctor about anything I am doing that has the ability to affect my health, that I
                            should
                            follow my doctors recommendations, and that I am not being advised to discontinue any
                            medications or
                            treatments made by my doctor. It is also recommended to have any medication that I am on
                            closely
                            monitored while participating in activities or exercises that could affect my health. I
                            understand
                            that this program is not a replacement for medical advice or psychiatric care and that I am
                            not
                            being discouraged from seeing my medical doctor. Rather, if I have a health issue, I
                            understand it
                            is recommended to continue to see my doctor, to do whatever is needed, and to continue to
                            monitor my
                            health.
                          </Typography>
                          <br/>
                          <Typography variant="body1">
                            I fully realize that my health is my responsibility and I release Brandy Gillmore and all
                            affiliates, officers, and employees, from any health-related issues that I might have
                            currently or
                            may have in the future. Any dispute arising under this Agreement shall be finally settled on
                            an
                            individual basis in accordance with the Comprehensive Arbitration Rules of the Judicial
                            Arbitration
                            and Mediation Service, Inc. (“JAMS”).
                          </Typography>
                          <br/>
                          <Typography variant="body1">
                            I also understand that each persons results with the program are their own responsibility.
                            This information is educational and that there is no guarantee of health, success or money
                            as no one is able to guarantee money and/or success. In short, it is up to you to make
                            things happen in your life and your life is your responsibility. The information contained
                            in this video set is here to assist you in doing so! That said, we sincerely hope you really
                            use whatever makes sense to you in your life and use it to its fullest to help you change
                            your health and your life!
                          </Typography>
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                          Accept
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </form>
                </Container>
              </Paper>
            </Grid>
          </Container>
          <Copyright textColor={theme.palette.primary.light}/>
        </Container>
      </ThemeProvider>
    );// End return
  };// End render
}// End class

const mapStateToProps = (state) => {
  return ({
    error: state.error
  });
};

const mapDispatchToProps = dispatch => ({
  signup: user => dispatch(signup(user))
});


Signup = withStyles(styles, {withTheme: true})(Signup);

Signup = connect(
  mapStateToProps,
  mapDispatchToProps
)(Signup);

Signup = reduxForm({
  form: 'SignupForm',
  Signup,
  validate
})(Signup);

export default Signup;